export enum TextDirection {
  rtl = 1,
  ltr,
}
